import { render, staticRenderFns } from "./handle.vue?vue&type=template&id=268e57fb&scoped=true"
import script from "./handle.vue?vue&type=script&lang=js"
export * from "./handle.vue?vue&type=script&lang=js"
import style0 from "./handle.vue?vue&type=style&index=0&id=268e57fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268e57fb",
  null
  
)

export default component.exports